const base64toURL = (data?: string | null, contentType?: string | null) => {
    if (contentType !== "image/png" && contentType !== "image/gif" && contentType !== "image/jpeg" && contentType !== "image/jpg" && contentType !== "image/tif") {
        switch(contentType) {
            case "1":
                return `${process.env.PUBLIC_URL}/assets/stock-plotplans/1.jpg`;
            case "2":
                return `${process.env.PUBLIC_URL}/assets/stock-plotplans/2.jpg`;
            case "3":
                return `${process.env.PUBLIC_URL}/assets/stock-plotplans/3.jpg`;
            case "4":
                return `${process.env.PUBLIC_URL}/assets/stock-plotplans/4.jpg`;
            default:
                throw new Error("Invalid content type");
        } 
      }
      if (data == null || data?.length === 0 || contentType == null || contentType?.length === 0) {
        throw new Error("Image data null or empty");
      }
    
      const byteCharacters = atob(data);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
    
      const image = new Blob([byteArray], { type: contentType });
      const imageUrl = URL.createObjectURL(image);
      return imageUrl;
};

export default base64toURL;